import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/Sale/Client/SaleClientList/components/List';
import Search from '#app/View/Sale/Client/SaleClientList/components/Search';
import ClientEntryPoints from '#app/entrypoints/client';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { Channel } from '#app/typings/channel';
import { ClientList } from '#app/typings/client';

export type Filters = {
  number?: string;
  email?: string;
  firstname?: string;
  lastname?: string;
  zipCode?: string;
  channels?: Channel[];
  shops?: number[];
};

const SaleOrderClientList: React.FC = () => {
  const { setFilters, filters, ...props } = useCollectionPaginated<ClientList, Filters>(
    ClientEntryPoints.getCollection,
    { sorting: { sortName: 'createdAt', sortDirection: 'desc' } },
  );

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des clients', context: 'Vente' }}>
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <List {...props} />
    </ContentViewComponent>
  );
};

export default SaleOrderClientList;
